module.exports = __webpack_public_path__ + "img/1892.f64a1a16.gif";